import React from 'react'
import { TextareaItem } from 'antd-mobile';
import { Input } from 'antd';
import { BrowserView, MobileView } from "react-device-detect";

export const TextArea = (props) => {
  return (
    <>
      <MobileView>
        <div style={{ borderBottomStyle: 'groove', color: '#978897', fontSize: '14px', fontVariant: 'tabular-nums', marginTop: '-10px' }}>
          <TextareaItem
            value={props.value ?? ''}
            type={props.type ?? 'text'}
            disabled={props.disabled ?? false}
            autoHeight
            placeholder={props.placeholder}
            onChange={(value) => {
              if (props.onChange) {
                props.onChange(value);
              }
            }}
          >{props.label}</TextareaItem>
        </div>
      </MobileView>
      <BrowserView>
        <Input.TextArea
          value={props.value ?? ''}
          onChange={(value) => {
            if (props.onChange) {
              props.onChange(value);
            }
          }}
        />
      </BrowserView>
    </>
  )
}
